import React, { useState, useEffect, useCallback } from "react";

import Form from '../../components/form/admin/coeficientes';

import { getData } from "../../helpers/auth";
import { uriList, TOKEN_USER } from "../../helpers/config";
import { getItemCrypt } from '../../helpers/auth'

import { DefaultOrder, sortByString, sortByNumber, compareDate } from '../../helpers/general';

function Coeficientes({ ...props }) {
    const [coeficientes, setCoeficientes] = useState([]);
    const [coeficientesC, setCoeficientesC] = useState([]);
    const [tabelas, setTabelas] = useState([]);
    const [total, setTotal] = useState(false);
    const [actualPage, setActualPage] = useState(0);
    const [filterOptions, setFilterOptions] = useState(false);
    const [dateVisible, setDateVisible] = useState('todos');
    const [modal, setModal] = useState(false);
    const [clickedTr, setClickedTr] = useState("")
    const [ascDesc, setAscDesc] = useState(true);
    const [coeficiente_filter, setCoeficienteFilter] = useState("");
    const [useNewLayout, setUseNewLayout] = useState(false)
    const [url, setURL] = useState('')

    const handleOption = (e) => {
        let label = e.currentTarget.dataset.label;
        let value = e.currentTarget.value
        let newDetailed;

        if (value !== "todos" && value !== "") {
            newDetailed = coeficientesC.filter((proposta) => {
                if (label = "coeficiente_filter") {
                    let result = (proposta["tabela"] && proposta["tabela"].toLowerCase().indexOf(value.toLowerCase()) >= 0) ||
                        (proposta["convenio"] && proposta["convenio"].toLowerCase().indexOf(value.toLowerCase()) >= 0)

                    return result
                }
                else
                    return proposta[label] === value
            });


            setCoeficientes(newDetailed);
            setActualPage(0);
        } else {
            setCoeficientes(coeficientesC);
            setActualPage(0);
        }
    };

    const handleCoeficiente = (e) => {
        let value = e.currentTarget.value
        setCoeficienteFilter(value);
        handleOption(e)
    }

    const handlePage = (e) => {
        setActualPage(e.currentTarget.value);
    };

    const createFilter = (obj) => {
        let newObj = {
            coeficiente: [],
            convenio_id: [],
            tabela_id: [],
        };

        for (let o of obj) {
            for (let i in o) {
                if (newObj[i]) {
                    newObj[i].push(o[i]);
                }
            }
        }

        for (let i in newObj) {
            newObj[i] = [...new Set(newObj[i])];
        }

        setFilterOptions(newObj);
    };

    const _tabelas = useCallback(() => {
        getData({ uri: uriList("tabelas") })
            .then((res) => {
                if (res.status && res.status > 200) throw new Error();
                setTabelas(res);
            })
            .catch((e) => {
                return false;
            });
    })

    const _coeficientes = useCallback(() => {
        getData({ uri: uriList("coeficientes") })
            .then((res) => {
                if (res.status && res.status > 200) throw new Error();
                DefaultOrder('coeficientes', res.map((coeficientes) => coeficientes), setCoeficientes)
                createFilter(res.map((coeficientes) => coeficientes))
                setCoeficientesC(res)
            })
            .catch((e) => {
                return false;
            });
    })

    const _user = useCallback(() => {
        const _userData = getItemCrypt(TOKEN_USER);
        const _id = JSON.parse(_userData || {})

        getData({ uri: uriList("usuarios") + "/" + _id?.id })
            .then((res) => {

                if (res.status && res.status > 200) throw new Error();

                let _returnData = {};
                if (typeof res === "object" && res !== null) {
                    _returnData = res;
                } else {
                    try {
                        _returnData = JSON.parse(res) || {};
                    } catch (e) {
                        _returnData = {};
                    }
                } 

                const layoutFront =
                    _returnData.layout_front1?.toLowerCase() ??
                    process.env.REACT_APP_LAYOUT_FRONT?.toLowerCase();

                setUseNewLayout(layoutFront === "novo");
            })
            .catch((e) => {
                console.log(e)
                return false;
            });
    })

    useEffect(() => {
        _coeficientes()
        _tabelas()
        _user()

        const token = localStorage.getItem('@inconta-token');
        const user = localStorage.getItem('@inconta-user')
        setURL(`${process?.env?.REACT_APP_URL_NEW_LAYOUT}/coeficientes/${encodeURIComponent(token)}/${encodeURIComponent(user)}`)
    }, []);

    const sortArrObj = (key, type) => {
        let arr = [...coeficientes];
        let asc = !ascDesc

        arr = arr.sort((a, b) => {
            if (type === 'string') {
                if (asc) {
                    setAscDesc(asc);
                    return sortByString(a, b, key, type);
                } else {
                    setAscDesc(asc);
                    return sortByString(b, a, key, type);
                }
            } else if (type === 'numeric') {
                if (asc) {
                    setAscDesc(asc);
                    return sortByNumber(a, b, key, type);
                } else {
                    setAscDesc(asc);
                    return sortByNumber(b, a, key, type);
                }
            } else {
                if (asc) {
                    setAscDesc(asc);
                    return compareDate(new Date(a[key]), new Date(b[key])) ? 1 : -1;
                } else {
                    setAscDesc(asc);
                    return compareDate(new Date(b[key]), new Date(a[key])) ? 1 : -1;
                }
            }
        });

        setCoeficientes(arr);
    };

    if (useNewLayout) {
        return (
            <div style={{ width: "100%", height: "82vh" }}>
                <iframe src={url} frameBorder="0" style={{ width: "100%", height: "100%", border: "none" }}></iframe>
            </div>
        )
    }

    return (
        <>
            <Form
                filterOptions={filterOptions}
                handleOption={handleOption}
                setDateVisible={setDateVisible}
                coeficiente_filter={coeficiente_filter}
                handleCoeficiente={handleCoeficiente}
                setModal={setModal}
                setCoeficientes={setCoeficientes}
                setClickedTr={setClickedTr}
                sortArrObj={sortArrObj}
                clickedTr={clickedTr}
                coeficientes={coeficientes}
                tabelas={tabelas}
                actualPage={actualPage}
                handlePage={handlePage}
                dateVisible={dateVisible}
                total={total}
                callback={_coeficientes}
                context={props.context} />

            {modal}
        </>
    );
};

export default Coeficientes;
